import { FoodTypesDto } from "@gtpl/shared-models/masters";
import { ValueAdditionThreeType } from "../value-addition-three.entity";
import { ValueAdditionThreeDTO } from "./value-addition-three.dto";

export class ValueAddThreeTypeAdapter {
    convertDtoToEntity(dtoObj: ValueAdditionThreeDTO,  isUpdate: boolean = false ): ValueAdditionThreeType {
        try {
            const entityObj = new ValueAdditionThreeType();
            entityObj.createdUser = dtoObj.createdUser;
            entityObj.code = dtoObj.code;
            entityObj.name = dtoObj.name;
            entityObj.remarks = dtoObj.remarks;
            if (dtoObj.valueAdditionThreeId) {
                entityObj.valueAdditionThreeId = dtoObj.valueAdditionThreeId;
                entityObj.updatedUser = dtoObj.updatedUser;
            }
            entityObj.isActive = dtoObj.isActive;
            return entityObj;
        } catch (Error) {
            throw Error;
        }
    }

    public convertEntityToDto(employeeObject: ValueAdditionThreeType): ValueAdditionThreeDTO {
        const foodTypeDetailsDTO= new ValueAdditionThreeDTO;
        foodTypeDetailsDTO.valueAdditionThreeId = employeeObject.valueAdditionThreeId;
        foodTypeDetailsDTO.code = employeeObject.code;
        foodTypeDetailsDTO.name = employeeObject.name;
        foodTypeDetailsDTO.remarks = employeeObject.remarks;
        foodTypeDetailsDTO.isActive = employeeObject.isActive;
        foodTypeDetailsDTO.createdAt = employeeObject.createdAt;
        foodTypeDetailsDTO.updatedAt = employeeObject.updatedAt;
        foodTypeDetailsDTO.createdUser = employeeObject.createdUser;
        foodTypeDetailsDTO.updatedUser = employeeObject.updatedUser;
        foodTypeDetailsDTO.versionFlag = employeeObject.versionFlag;
        return foodTypeDetailsDTO;
      }
}